import {
  Box,
  InputAdornment,
  Popover,
  TextField,
  useTheme,
} from "@mui/material";
import { format, isWithinInterval } from "date-fns";
import { useState } from "react";
import { DayPicker } from "react-day-picker";
import { it } from "date-fns/locale";

import "react-day-picker/style.css";
import { useIsMobile } from "../../hook/useIsMobile";
import { CalendarMonth } from "@mui/icons-material";

const FieldNotesDatePicker = ({
  label,
  id,
  selectedDate,
  handleDateSelect,
  disabledDays = [],
  error,
  disabledRanges = [],
  disabled,
  toYear = 2050,
  minDate,
  maxDate,
}) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleDateChange = (date) => {
    if (selectedDate && date && date.getTime() === selectedDate.getTime()) {
      handleDateSelect(null);
      handleClose();
      return;
    }
    if (date) {
      handleDateSelect(date);
      handleClose();
    } else {
      handleClose();
    }
  };

  const isDateDisabled = (date) => {
    if (minDate && date < minDate) return true;
    if (maxDate && date > maxDate) return true;
    return disabledRanges.some((range) =>
      isWithinInterval(date, { start: range.start, end: range.end }),
    );
  };

  return (
    <>
      <TextField
        id={id}
        label={label}
        variant="outlined"
        placeholder="Scegli data"
        value={selectedDate ? format(selectedDate, "dd/MM/yyyy") : ""}
        onClick={handleOpen}
        sx={{
          borderRadius: theme.shape.borderRadius * 7,
          backgroundColor: "#E9EEF0",
          height: 40,
          width: isMobile ? "100%" : 120,
          fontSize: "12px",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiInputBase-input::placeholder": {
            textAlign: "center",
            fontSize: "12px",
            opacity: 1,
            color: "#616161",
          },
          "& .MuiInputBase-input": {
            textAlign: "center",
            fontSize: "12px",
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ marginRight: 0 }}>
              <CalendarMonth sx={{ fontSize: "15px", color: "#616161" }} />
            </InputAdornment>
          ),
          inputProps: {
            style: {
              textAlign: "center",
              fontSize: "12px",
              padding: 0,
              height: "40px",
              display: "flex",
              alignItems: "center",
            },
          },
        }}
        error={!!error}
        helperText={error}
        disabled={disabled}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box p={2}>
          <DayPicker
            mode="single"
            selected={selectedDate}
            onDayClick={handleDateChange}
            locale={it}
            weekStartsOn={1}
            disabled={[isDateDisabled, disabledDays]}
            style={{
              "--rdp-accent-color": theme.palette.primary.main,
            }}
            captionLayout="dropdown"
            endMonth={new Date(toYear, 12)}
          />
        </Box>
      </Popover>
    </>
  );
};

export default FieldNotesDatePicker;
